import { createFileRoute } from '@tanstack/react-router'
import { StaffBooking } from '../../../../components/StaffBooking'

export const Route = createFileRoute('/platform/desa/$desaId/booking')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffBooking desaId={desaId} />
  },
})
